import React from 'react';

const address = () => (
  <address>
    Turvallisuuskomitea<br />
    Puolustusministeriö<br />
    Eteläinen Makasiinikatu 8<br />
    PL 31, 00131 HELSINKI<br />
  </address>
);

const phone = () => (
  <address>
    Puhelin: +358 295 16001<br />
    Telefaksi: 09 160 88244
  </address>
);

const contact = () => (
  <address>
    Yhteydenotot: <a href="mailto:tk@turvallisuuskomitea.fi">tk@turvallisuuskomitea.fi</a>
  </address>
);

export default () => (
  <div className="bottom">
    <div>
      <img src="https://turvallisuuskomitea.fi/images/pm_site/tk-footer-valk.png" alt="logo" />
      <br />
      <br />
      {address()}
      {phone()}
      {contact()}
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Footer.jsx